enum GcpError {
    NONE = '',
    FAIL = 'fail',

}

export default GcpError;
